import Vue from 'vue'
import Vuex from 'vuex'
import {saveInSessionStorage} from '../assets/js/util/common_util'
import actions from './actions'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // *************************************************************
    // 注意：初始值不能定义成undefined，否则全局store也会变成undefined
    userinfo: {
      isLogin: false,
      isVip: false,
    },
    majors: [],
    colleges: [],
    subjects: [],
    years: [],
  },
  mutations: {
    setUserInfo: function (state, userinfo){
      state.userinfo = userinfo
      userinfo.isLogin = true
      userinfo.isVip = ['root','admin','vip'].indexOf(userinfo.role)>=0

      // 为避免用户按浏览器刷新按钮后，vuex中数据丢失
      // 将vuex数据缓存入sessionStorage，用户不关闭浏览器，sessionStorage中数据一直存在
      saveInSessionStorage(userinfo, 'userinfo')
    },
    logout: function(state) {
      state.userinfo = {
        isLogin: false,
        isVip: false
      }
      saveInSessionStorage(state.userinfo, 'userinfo')
      state.isLogin = false
      saveInSessionStorage(state.isLogin, 'isLogin')
    },
    setMajors: function(state, majors){
      state.majors = majors

      saveInSessionStorage(state.majors, 'majors')
    },
    setColleges: function(state, colleges) {
      state.colleges = colleges
      saveInSessionStorage(state.colleges, 'colleges')
    },
    setSubjects: function(state, subjects) {
      state.subjects = subjects
      saveInSessionStorage(state.subjects, 'subjects')
    },
    setYears: function(state, years) {
      state.years = years
      saveInSessionStorage(state.years, 'years')
    },
  },
  actions,
  modules: {
  }
})
